<template>
  <div>
    <h4 v-if="title">{{ title }}</h4>
    <apexchart v-if="chartOptions !== null" :height="extra.height" :options="chartOptions" :series="chartOptions.series"></apexchart>
    <div v-else class="d-flex justify-content-center">
      <div class="spinner-border text-primary" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['title', 'extra'],
  data () {
    return {
      chartOptions: null
    }
  },
  sockets: {
    getEnergyHourlyData: function (data) {
      if (data.reqData.serial === this.extra.serial) {
        this.chartOptions = data.chartOptions
      }
    }
  },
  watch: {
    extra: function () {
      this.chartOptions = null
      this.requestChart()
    }
  },
  created () {
    this.requestChart()
  },
  methods: {
    requestChart () {
      this.$socket.emit('getEnergyHourlyData', { serial: this.extra.serial, reqType: 'pageLoad' })
    }
  }
}
</script>
